import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import facebookPixel from '../../../../services/facebook_pixel';
import lockIcon from '../../../../../images/icons/cart/lock.svg';
import Button from '../../../../ui_kit/button/Button';
import MODALS from '../../../../modals/constants/modals';
import { modalsActions } from '../../../../modals/actions';
import { lineItemsObjectsSelector } from '../../../../checkout/selectors/line_items';
import { userObjectSelector } from '../../../../user/selectors/user';
import { cartActions } from '../../../actions';
import { guestTokenSelector } from '../../../../checkout/selectors/order';

class CheckoutButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onClickHandler = () => {
    const {
      lineItems, openSignInModal, user, goToCheckout, guestToken,
    } = this.props;
    const eventId = guestToken;

    if (!user && lineItems.filter((lineItem) => lineItem.frequency > 0).length > 0) {
      openSignInModal();
      document.addEventListener('userLoggedIn', () => {
        facebookPixel.multiPurposeTrack('InitiateCheckout', eventId);
        goToCheckout();
      });

      return;
    }

    this.setState({
      loading: true,
    });

    facebookPixel.multiPurposeTrack('InitiateCheckout', eventId);
    goToCheckout();
  };

  render() {
    const { loading } = this.state;

    return (
      <Button
        id="checkout-link"
        text="CHECKOUT"
        icon={<img src={lockIcon} alt="" />}
        onClickHandler={this.onClickHandler}
        loading={loading}
      />
    );
  }
}

CheckoutButton.propTypes = {
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  openSignInModal: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
  goToCheckout: PropTypes.func.isRequired,
  guestToken: PropTypes.string,
};

const mapStateToProps = (state) => ({
  lineItems: lineItemsObjectsSelector(state),
  user: userObjectSelector(state),
  guestToken: guestTokenSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openSignInModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.SIGN_IN_FOR_PRODUCT_SUBSCRIPTION,
  })),
  goToCheckout: () => dispatch(cartActions.checkoutRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutButton);
